module.exports = __webpack_public_path__ + "static/media/boleto-fisico.d7a0a54a.svg";